import React from 'react';

function Settings(){
	return(
		<div className="body-content bg-fff pt-70l-110m-60s pb-40">
		
			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-source-sans font-size-24 font-weight-800 bb1-555 uppercase italic pb-5">Settings</div>
					</div>
				</div>
			</div>
			
		</div>
	);
}

export default Settings;